// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","LeftMenu":"ir_a bht_tr","LeftMenu__link":"ir_b bht_vt bht_a bht_rc","LeftMenu__link__icon":"ir_c"};